import { FC } from 'react'
import classNames from 'classnames'
import { CircleQuestionIcon } from '@/atoms/Icons/CircleQuestionIcon'
import { CaptionMD } from '@/atoms/Text'

interface Props {
  className?: string
  variant?: 'info'
  text: string
  ctaComponent?: React.ReactNode
}

export const Callout: FC<Props> = ({ className, variant = 'info', text, ctaComponent }) => {
  return (
    <div
      className={classNames('flex items-center gap-1 rounded-lg border-2 border-info-200 bg-info-100 p-3', className)}
    >
      {variant === 'info' && <CircleQuestionIcon color="info-700" size={18} className="shrink-0" />}
      <CaptionMD>{text}</CaptionMD>
      {ctaComponent}
    </div>
  )
}
